import React from 'react';
import { components } from 'react-select';
import PropTypes from 'prop-types';
import { Label, Input } from 'reactstrap';

const optionDomId = value => `checkbox_${String(value).replace(/\s+/g, '-')}`;

const Option = (props) => {
    const useRouteSearchByRouteId = props.selectProps?.useRouteSearchByRouteId;
    const showSecondary = useRouteSearchByRouteId && props.data?.secondaryText;
    const inputId = optionDomId(props.value);

    return (
        <components.Option { ...props }>
            <Label for={ inputId }>
                { showSecondary ? (
                    <>
                        <span className="d-block">{ props.data.text }</span>
                        <span className="search__option-secondary">{ props.data.secondaryText }</span>
                    </>
                ) : (props.data?.text || props.label) }
            </Label>
            <Input
                id={ inputId }
                type="checkbox"
                checked={ props.isSelected }
                onChange={ () => null }
            />
        </components.Option>
    );
};

Option.propTypes = {
    value: PropTypes.string.isRequired,
    isSelected: PropTypes.bool.isRequired,
    data: PropTypes.object,
    label: PropTypes.string,
    selectProps: PropTypes.object,
};

Option.defaultProps = {
    data: {},
    label: '',
    selectProps: {},
};

export default Option;
